import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ShipperQuoteRequest } from "api/rest/quote-requests";
import set from "lodash/set";
import usableActions from "utils/store/usableActions";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type DeepPartial<T> = T extends Record<any, any>
  ? {
      [P in keyof T]?: DeepPartial<T[P]>;
    }
  : T;

type QuoteRequestState = DeepPartial<ShipperQuoteRequest>;

type State = {
  quoteRequest: QuoteRequestState;
  isEditing: boolean;
};

const initialState: State = {
  quoteRequest: {},
  isEditing: false,
};

const updateQuoteRequestSlice = createSlice({
  name: "updateQuoteRequestSlice",
  initialState,
  reducers: {
    setQuoteRequest: (state, action: PayloadAction<QuoteRequestState>) => {
      if (!action.payload) {
        return;
      }

      state.quoteRequest = {
        ...state.quoteRequest,
        ...action.payload,
        load_spec: {
          ...state.quoteRequest.load_spec,
          ...action.payload.load_spec,
        },
      };
    },

    setQuoteRequestByPath: (
      state,
      action: PayloadAction<{
        path: string;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        value: any;
      }>
    ) => {
      set(state.quoteRequest, action.payload.path, action.payload.value);
    },

    // KEEP: ftlSlice and drayage reducers (actively used)
    resetState: () => {
      return initialState;
    },

    setState: (state, action: PayloadAction<Partial<State>>) => {
      return { ...state, ...action.payload };
    },
  },
});

export const updateQuoteRequestActions = usableActions(updateQuoteRequestSlice.actions);
export default updateQuoteRequestSlice;
